// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__25UsI","inner":"Form_inner__28bgD","range":"Form_range__x8ql1","name":"Form_name__1YsYr","actions":"Form_actions__3uuos"};